import { InjectionToken } from '@angular/core';

export const B2CRouterVerbose = {
  None: 0,
  Error: 1,
  Warn: 2,
  Infos: 3,
  Debug: 4,
} as const;
export type B2CRouterVerbose =
  typeof B2CRouterVerbose[keyof typeof B2CRouterVerbose];

export const B2C_ROUTER_VERBOSE_TOKEN = new InjectionToken<B2CRouterVerbose>(
  'b2c-router-verbose'
);
